export enum LoginEventType {
    Login,
    Logout,
    Refresh
}